//
// --- Types ---

export type EmailLogStatusCodeType = keyof typeof EMAIL_LOG_STATUS_TYPE;
export type EmailLogStatusValueType = typeof EMAIL_LOG_STATUS_TYPE[EmailLogStatusCodeType];

export type EmailMessageTypeKey = keyof typeof EMAIL_MESSAGE_TYPE;
export type EmailMessageType = typeof EMAIL_MESSAGE_TYPE[EmailMessageTypeKey];

//
// --- Constants ---

export const EMAIL_LOG_STATUS_TYPE = {
  RAC: 'Request Access Cancelled',
  RAR: 'Request Access Reminded',
  RDI: 'Request Access Denied',
  RDN: 'Request Access Denied',
  RSI: 'Request Access Approval Invite',
  RSN: 'Request Access Approved',
  RSR: 'Requested Access',
  SIV: 'Invited to Register',
  SNO: 'Notified of Event',
  SRI: 'Re-invited to Register',
  SRN: 'Re-notified of Event'
} as const;

export const EMAIL_MESSAGE_TYPE = {
  INVITATION: 'INVITATION',
  NOTIFICATION: 'NOTIFICATION'
} as const;
